import gql from 'graphql-tag'

export default gql`
query getShopCRs($id: ID!) {
	cashAssist {
		getShop(id: $id) {
			id
			cashRegisters {
				id
				name
				hardwareId
				deviceType
			}
		}
	}
}`
